export const eventSubscribe = (eventName, listener) => {
  document.addEventListener(eventName, listener);
};

export const eventUnsubscribe = (eventName, listener) => {
  document.removeEventListener(eventName, listener);
};

export const eventDispatch = (eventName, data) => {
  const event = new CustomEvent(eventName, { detail: data });
  document.dispatchEvent(event);
};

export const triggerNativeEventFor = (elm, { event, ...valueObj }) => {
  if (!(elm instanceof Element)) {
    throw new Error(`Expected an Element but received ${elm} instead!`);
  }

  const [prop, value] = Object.entries(valueObj)[0] ?? [];
  const desc = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(elm), prop);
  desc.set.call(elm, value);
  elm.dispatchEvent(new Event(event, { bubbles: true }));
};
